// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"DesktopHeader_Wrapper__39kxx"};